<style scoped>
  .project-number{color: #333333;font-size: 14px;margin-left: 40px;display: inline-block;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .list-panel{background-color: white;padding:0 40px}
  .list-title{color: #464c5b;font-size: 16px;font-weight: bold;}
  .list-schedule{color: #626c70;font-size: 14px;}
  .list-host-text{font-size: 14px;color: #626c70;display: inline-block;margin-right: 19px;vertical-align: text-top;}
  .list-host-avatar{width: 30px;height: 30px;border-radius: 15px;margin-right: 10px;}
  .list-pending{color:#626c70;font-size: 14px;display: inline-block;vertical-align: text-top;margin-top: 4px;}
  .notice-background{background: url("/img/sys/bg1.png");height: 140px;}
  .search >>> .ivu-input{width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .approval-state{cursor:pointer;font-size: 12px;background-color:rebeccapurple;color:white;border-radius:5px;padding:3px;margin-right:5px}
</style>

<template>
  <div>
    <!--添加-筛选-->
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row style="background-color: #fcfcfc;line-height:80px;">
      <Col span="22">
        <div class="project-number">
          <div style="display: inline-block;padding-right: 10px;">共有<span style="color: #00a2e9;font-size: 24px;">{{search.total}}</span>个项目</div>
          <div style="border-right: 1px solid #e3e3e3;display: inline-block;height: 40px;vertical-align: middle;line-height: 100px;"></div>
        </div>
        <div style="display: inline-block;vertical-align: top;cursor:pointer;">
          <Dropdown trigger="click">
            <img style="margin: 0 10px;vertical-align: middle" src="/img/project/add-icon.png"/>
            <p class="btn-default">新建案件</p>
            <DropdownMenu slot="list">
              <router-link v-for="(item,index) in typeList" :to="{name:item.routeName,query:{id:item.id}}"><DropdownItem>{{item.name}}</DropdownItem></router-link>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Col>
      <!--<Col span="2">-->
        <!--<img style="margin: 0 10px;vertical-align:middle" src="/img/project/screen-icon.png"/>-->
        <!--<p style="color: #6c767a" class="btn-default">筛选</p>-->
      <!--</Col>-->
    </Row>
    <!--搜索-->
    <Row  style="background-color: white;border-bottom: 1px solid #d7dde4">
      <Col span="14" style="margin-top: 22px;">
        <div style="position: relative;margin-left: 40px;margin-bottom: 22px;">
          <Input class="search"  placeholder="搜索案件标题" @keyup.enter.native="caseList()" v-model="search.text"></Input>
          <div style="background-color: #00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 4px;text-align: center;left: 310px;cursor:pointer;" @click="caseList()">
            <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
          </div>
        </div>
      </Col>
      <!--下拉-->
      <Col span="5"  style="margin-top: 22px;">
        <Dropdown trigger="click">
          <div style="color: #9599b2;font-size: 14px;margin-top: 10px;cursor:pointer;">
            案件类型
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list" v-if="typeList.length>0">
            <span @click="search.type='';caseList()"><DropdownItem>所有类型</DropdownItem></span>
            <span v-for="(item,index) in typeList" @click="search.type=item.id;caseList()"><DropdownItem :name="item.id">{{item.name}}</DropdownItem></span>
          </DropdownMenu>
        </Dropdown>
      </Col>
      <!--下拉-->
      <Col span="5"  style="margin-top: 22px;">
        <Dropdown trigger="click">
          <div style="color: #9599b2;font-size: 14px;margin-top: 10px;cursor:pointer;">
            进度筛选
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <span @click="search.completed='';caseList()"><DropdownItem>所有进度</DropdownItem></span>
            <span @click="search.completed=1;caseList()"><DropdownItem>已完成</DropdownItem></span>
            <span @click="search.completed=0;caseList()"><DropdownItem>未完成</DropdownItem></span>
          </DropdownMenu>
        </Dropdown>
      </Col>
    </Row>
    <!--列表面板-->
    <div class="list-panel">
      <Row justify="center" v-for="(item,index) in list">
        <!--sealSrc(item.caseType,item.causeType)-->
        <!--'projectSeal'-->
        <!--<router-link :to="{name:item.approvalState!='暂无'||item.seal==1?'projectTask':sealSrc(item.caseType,item.causeType),query:{caseId:item.id,taskId:item.taskId,seal:item.seal}}">-->
        <router-link :to="{name:'projectTask',query:{caseId:item.id,taskId:item.taskId,seal:item.seal,filed:item.filed}}">
          <Col span="24" style="height: 134px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;">
            <Col span="14" style="line-height: 38px;">
              <p class="list-title">{{item.name}}</p>
              <p class="list-schedule">
                审批状态：
                <span class="approval-state">{{item.approvalState}}</span>
                | 合同状态：
                <span v-if="item.seal==false" class="approval-state">待签署</span>
                <span v-else class="approval-state">已签署</span>
                | 创建日期：{{item.createDate}}
              </p>
            </Col>
            <Col span="5">
              <p class="list-host-text">主办</p>
              <Avatar class="list-host-avatar" v-if="i.name" v-for="i in item.manager">{{i.name[0]}}</Avatar>
            </Col>
            <Col span="5">
              <p class="list-pending">待处理任务 <span style="color: #00a2e9;">{{item.completed}}</span> / {{item.missionTotal||0}}</p>
            </Col>
          </Col>
        </router-link>
      </Row>
      <Row>
        <Col span="24" style="margin:40px 0 57px 0;">
          <Page
              :show-sizer="true"
              :show-total="true"
              @on-page-size-change="search.pageSize=$event;caseList()"
              :total="search.total"
              :page-size="search.pageSize"
              :page-size-opts="[5,10,15]"
              show-elevator
              @on-change="search.page = $event;caseList()"
          />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "projectList",
    data () {
      return {
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          type:'',//案件类型
          text:'',//搜索文字
          completed:'',//0/1
        },
        list : [],//案件列表
        typeList:[],
      }
    },
    methods:{
      sealSrc:function(caseType,causeType){
        if(caseType==1){
          if(causeType==1){
            return 'projectContractAdviserCivil'
          }
          if(causeType==2){
            return 'projectContractAdviserAdministration'
          }
          if(causeType==3){
            return 'projectContractAdviserCriminal'
          }
        }
        if(caseType==2){
          return 'projectContractLitigation'
        }
        if(caseType==3){
          return 'projectContractSpecial'
        }
      },
      caseList : function () {
        var _this = this
        _this.list = []
        _this.send({
          headers: "C/CaseList",
          data: {
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
            temp:_this.search.completed,
            caseType:_this.search.type,
          },
          success : function (res) {
            for(var index in res.list){
              var tempArr = []
              for(var secIndex in res.list[index].CaseExecutorId){
                tempArr.push({
                  name:res.list[index].CaseExecutorId[secIndex].UserName,
                  id:res.list[index].CaseExecutorId[secIndex].UserId,
                })
              }
              _this.search.total = res.count
              _this.list.push({
                name:res.list[index].CaseTitle,
                id:res.list[index].CaseId,
                taskId:res.list[index].MissionId,
                createDate:res.list[index].CaseCreateTime,
                manager:tempArr,
                filed:res.list[index].RecordData,
                seal:res.list[index].Visa,
                completed:res.list[index].MissionComplete,
                missionTotal:res.list[index].MissionCount,
                approvalState:res.list[index].Approval,
                caseType:res.list[index].CaseTypeId,
                causeType:res.list[index].CaseClassId,
              })
            }
          }
        })
      },
      getTypeList : function () {
        var _this = this
        _this.typeList = []
        _this.send({
          headers: "C/CaseTypeList",
          success : function (res) {
            for(var index in res.TypeList){
              var tempObj =  {
                id:res.TypeList[index].CaseTypeId,
                name:res.TypeList[index].CaseTypeTitle,
              }
              if(tempObj.name.indexOf("诉讼")!=-1){
                tempObj.routeName = 'adviserStep1'
              }
              if(tempObj.name.indexOf('专项')!=-1){
                tempObj.routeName = 'specialStep1'
              }
              if(tempObj.name.indexOf('顾问')!=-1){
                tempObj.routeName = 'litigationStep1'
              }
              _this.typeList.push(tempObj)
            }
          }
        })
      },
    },
    mounted : function () {
      this.$store.state.project.create.step1.client = []
      this.$store.state.project.create.step1.opposed = []
      this.caseList()
      this.getTypeList()
    }
  }
</script>
